import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const getNeedReviewData = (state: RootState) => state.needReview;
